// Kwestionariusz sensomotoryczny dziecka — dane pytań.
// Źródło: autorski kwestionariusz gabinetu Sensorini (Olsztyn).
// Wersja skrócona (przesiewowa): usunięto duplikaty i pytania o niskiej wartości
// różnicującej; ujednolicono polaryzację — odpowiedź „Tak” zwykle sygnalizuje
// możliwą trudność. Pełną diagnozę i tak przeprowadza terapeuta w gabinecie.
// Struktura: sekcje zmysłowe -> podgrupy -> pytania (odpowiedź Tak / Nie).

export const SECTIONS = [
  {
    key: 'dotyk',
    title: 'Dotyk',
    groups: [
      {
        subtitle: '',
        questions: [
          'nadmiernie reaguje, gdy zostanie niespodziewanie dotknięte',
          'nie lubi przytulania lub go unika',
          'przeszkadzają mu metki, szwy lub nowe ubrania',
          'unika zabaw fakturami (piasek, plastelina, masy plastyczne, klej)',
          'niechętnie znosi mycie twarzy, czesanie włosów, obcinanie paznokci',
          'reaguje zbyt mocno na drobny ból (zadrapanie, uderzenie)',
          'chodzi na palcach',
          'często wkłada ręce lub przedmioty do buzi',
          'wydaje się nie zauważać, że się uderzyło lub pobrudziło',
        ],
      },
    ],
  },
  {
    key: 'przedsionek',
    title: 'Równowaga i ruch (układ przedsionkowy)',
    groups: [
      {
        subtitle: '',
        questions: [
          'łatwo traci równowagę, często się potyka i przewraca',
          'ma trudności z wchodzeniem i schodzeniem ze schodów',
          'boi się huśtania, zjeżdżalni lub odrywania stóp od podłoża',
          'unika kręcenia się i szybkiego ruchu (albo szybko czuje mdłości)',
          'nadmiernie poszukuje ruchu: kręcenia, huśtania, wirowania',
          'często buja się na krześle lub przyjmuje pozycję „do góry nogami”',
          'długo uczyło się jazdy na rowerze',
        ],
      },
    ],
  },
  {
    key: 'motoryka',
    title: 'Motoryka, koordynacja i napięcie mięśniowe',
    groups: [
      {
        subtitle: '',
        questions: [
          'wydaje się niezdarne, nieporadne ruchowo',
          'ma trudności z drobnymi czynnościami (guziki, sznurowadła, puzzle)',
          'ma trudność z trzymaniem ołówka lub długopisu',
          'szybko męczy się fizycznie',
          'ma wiotkie, obniżone napięcie mięśni („rozlane”, słaby chwyt)',
          'wydaje się zbyt napięte, sztywne, mocno ściska przedmioty',
          'nieprawidłowo siedzi — podpiera głowę, „zwisa” na krześle',
          'nadal nie ma ustalonej ręki dominującej',
        ],
      },
    ],
  },
  {
    key: 'autostymulacje',
    title: 'Zachowania autostymulacyjne i autoagresywne',
    groups: [
      {
        subtitle: '',
        questions: [
          'buja się lub kiwa głową',
          'macha albo trzepocze rękami, podskakuje w miejscu',
          'nadmiernie gryzie i żuje przedmioty (rękawy, ołówki, zabawki)',
          'zaciska lub zgrzyta zębami',
          'uderza głową lub ciałem o przedmioty',
          'gryzie, szczypie lub uderza samo siebie',
        ],
      },
    ],
  },
  {
    key: 'wzrok',
    title: 'Wzrok',
    groups: [
      {
        subtitle: '',
        questions: [
          'ma zdiagnozowaną wadę wzroku',
          'wydaje się nadwrażliwe na światło (mruży lub zasłania oczy)',
          'ma trudność z podążaniem wzrokiem, gubi miejsce podczas czytania',
          'odwraca litery lub cyfry (b/d, 14/41)',
          'skarży się na bóle głowy podczas lub po patrzeniu z bliska / czytaniu',
        ],
      },
    ],
  },
  {
    key: 'sluch',
    title: 'Słuch',
    groups: [
      {
        subtitle: '',
        questions: [
          'ma zdiagnozowaną wadę słuchu',
          'zatyka uszy lub boi się głośnych bądź konkretnych dźwięków',
          'łatwo rozprasza się przez dźwięki tła (radio, gwar)',
          'wydaje się nie słyszeć lub nie reaguje na polecenia słowne',
          'wymaga kilkukrotnego powtarzania poleceń',
          'ma opóźniony rozwój mowy',
        ],
      },
    ],
  },
  {
    key: 'jedzenie',
    title: 'Jedzenie i smak',
    groups: [
      {
        subtitle: '',
        questions: [
          'je bardzo wybiórczo — tylko określone pokarmy lub konsystencje',
          'odmawia jedzenia z powodu smaku, zapachu lub konsystencji',
          'domaga się codziennie tych samych potraw',
          'ma odruch wymiotny przy niektórych pokarmach lub zapachach',
        ],
      },
    ],
  },
  {
    key: 'wech',
    title: 'Węch',
    groups: [
      {
        subtitle: '',
        questions: [
          'reaguje negatywnie na wiele zapachów',
          'obwąchuje przedmioty, jedzenie lub ludzi',
          'nie zauważa nieprzyjemnych zapachów',
        ],
      },
    ],
  },
  {
    key: 'zachowanie',
    title: 'Zachowanie, autoregulacja i koncentracja',
    groups: [
      {
        subtitle: '',
        questions: [
          'jest nadmiernie ruchliwe, nie może usiedzieć w miejscu',
          'łatwo się rozprasza',
          'jest impulsywne — działa lub odpowiada bez namysłu',
          'ma nieprzewidywalne wybuchy złości i trudno się uspokaja',
          'źle znosi zmiany rutyny lub miejsca',
          'ma trudności z zasypianiem lub snem',
          'bywa agresywne wobec innych dzieci',
        ],
      },
    ],
  },
  {
    key: 'rozwoj',
    title: 'Rozwój i wcześniejsze objawy',
    groups: [
      {
        subtitle: '',
        questions: [
          'z opóźnieniem osiągało kamienie milowe (siadanie, raczkowanie, chodzenie)',
          'jako niemowlę było niespokojne, dużo płakało',
          'było lub jest pod opieką specjalisty (neurolog, logopeda, psycholog)',
        ],
      },
    ],
  },
];

// Liczba wszystkich pytań (do progresu).
export const TOTAL_QUESTIONS = SECTIONS.reduce(
  (n, s) => n + s.groups.reduce((m, g) => m + g.questions.length, 0),
  0
);

// Stabilny identyfikator pytania: <sectionKey>-<groupIndex>-<questionIndex>
export const qid = (sKey, gIdx, qIdx) => `${sKey}-${gIdx}-${qIdx}`;
